<nav>
  <vui-button type="secondary" size="sm" (click)="resetFilters()">Filter zurücksetzen</vui-button>
  @for (key of facetKeys; track key) {
    @if (facetNodes()[key].length) {
      <app-multi-tree-select
        [label]="facetLabels[key]"
        [nodes]="facetNodes()[key]"
        [resetVersion]="resetVersion()"
        (selectionChange)="updateFilters(key, $event)"
      ></app-multi-tree-select>
    }
  }
</nav>
